import axios from 'axios';
import config from '../config'; // Import the base URL from the configuration file

/**
 * Converts an image to a specified format using the API.
 * @param imageData - The byte array of the image to be converted.
 * @param inputFormat - The format of the input image (e.g., 'webp' or 'avif').
 * @param outputFormat - The desired output format (e.g., 'png' or 'jpeg').
 * @returns A promise that resolves to the converted image as a Blob.
 */
const convertImage = async (
  imageData: Uint8Array,
  inputFormat: 'webp' | 'avif',
  outputFormat: 'png' | 'jpeg'
): Promise<Blob> => {
  try {
    // Convert the byte array to a Blob
    const mimeType = `image/${inputFormat}`;
    const blob = new Blob([imageData], { type: mimeType });

    // Create a FormData object
    const formData = new FormData();
    formData.append('file', blob, `image.${inputFormat}`); // Use the input format for the filename
    formData.append('output_format', outputFormat); // Append the desired output format

    // Make the API call
    const response = await axios.post(`${config.baseURL}/convertImage`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      responseType: 'blob', // Expect the response as a Blob
    });

    // Return the converted image as a Blob
    return response.data;
  } catch (error) {
    console.error('Error converting image:', error);
    throw new Error('Image conversion failed');
  }
};

export default convertImage;